var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _circle, _circle2, _circle3, _path8, _g3, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _g6, _g7, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_95697)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_95697)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 23.5383C386.615 51.7683 373.736 94.5986 337.753 120.628C301.868 146.587 258.296 144.264 237.819 115.957C217.236 87.5034 227.223 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.194 23.5383Z",
    stroke: "url(#paint1_linear_374_95697)",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87626C389.995 44.1854 382.299 86.8792 340.851 120.517C298.174 151.985 251.879 144.394 227.546 113.444C203.213 82.4934 212.137 31.0455 249.927 3.70892C287.716 -23.6277 337.782 -22.1135 360.2 8.87626Z",
    fill: "url(#paint2_linear_374_95697)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.05579C366.08 22.2062 367.773 40.0091 362.241 57.7807C356.7 75.576 343.934 93.1871 325.555 106.482C288.59 133.222 244.247 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95905C287.531 -24.6519 335.304 -20.337 355.843 8.05579Z",
    stroke: "url(#paint3_linear_374_95697)",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "url(#paint4_linear_374_95697)",
    stroke: "url(#paint5_linear_374_95697)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 88.4702L254.601 61.2299L317.655 69.0684L291.107 88.4702Z",
    fill: "url(#paint6_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.925714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.7696L301.212 34.6L290.531 87.4742L254.197 60.7696Z",
    fill: "url(#paint7_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.925714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_374_95697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "url(#paint8_linear_374_95697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#A9A7A6",
    strokeWidth: 0.925714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_95697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    fill: "url(#paint9_linear_374_95697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    stroke: "#A9A7A6",
    strokeWidth: 0.925714
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.724 83.7799L263.932 29.585L253.341 60.7148Z",
    fill: "url(#paint10_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "url(#paint11_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "url(#paint12_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "url(#paint13_linear_374_95697)",
    stroke: "#A9A7A6",
    strokeWidth: 0.462857
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint14_linear_374_95697)",
    strokeWidth: 2.87168
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_95697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.34 64.547C381.61 45.3291 374.46 29.9472 371.65 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.361 -28.912 278.102 -15.4846C227.842 1.80048 211.183 42.5319 209.396 60.5175L363.49 45.7588L367.786 47.728Z",
    fill: "#FEFFFE",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddddd_374_95697)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_95697)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "#523A48"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_374_95697)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint15_linear_374_95697)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 58.7772L29.7776 52.8262L31.7613 58.7772H27.7939Z",
    fill: "url(#paint16_linear_374_95697)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 52.8262L31.761 58.7772H34.4059L29.7773 52.8262Z",
    fill: "url(#paint17_linear_374_95697)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7284L25.1484 58.7773H27.7933L29.777 64.7284Z",
    fill: "url(#paint18_linear_374_95697)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 58.7773H27.7939L29.7776 64.7284L31.7613 58.7773Z",
    fill: "url(#paint19_linear_374_95697)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 58.7773H34.4059L29.7773 64.7284L31.761 58.7773Z",
    fill: "url(#paint20_linear_374_95697)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_374_95697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "white",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_95697)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_95697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 52,
    width: 10,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint21_linear_374_95697)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "url(#paint22_linear_374_95697)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "url(#paint23_linear_374_95697)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "url(#paint24_linear_374_95697)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint25_linear_374_95697)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint26_linear_374_95697)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_95697)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_95697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 52.8306L27.8072 58.7816L27.7793 58.7723L29.763 52.8213L29.7909 52.8306Z",
    fill: "url(#paint27_linear_374_95697)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7627 64.7235L31.7464 58.7725L31.7742 58.7818L29.7906 64.7328L29.7627 64.7235Z",
    fill: "url(#paint28_linear_374_95697)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_95697)",
    filter: "url(#filter7_f_374_95697)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_95697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 52,
    width: 5,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 52.8262L27.7646 58.7258H31.7834L29.7483 52.8262Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_95697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.9453,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.9453)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.8389,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.8389)",
    fill: "white",
    fillOpacity: 0.2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_95697)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 53.273,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint29_linear_374_95697)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5806 66.0778C54.6142 66.0778 53.7811 65.9223 53.0812 65.6113C52.3925 65.2891 51.7593 64.8059 51.1816 64.1616L52.8813 62.4786C53.2589 62.9119 53.6755 63.2507 54.131 63.4951C54.5975 63.7284 55.1363 63.845 55.7473 63.845C56.3027 63.845 56.7304 63.745 57.0303 63.5451C57.3413 63.3451 57.4969 63.0674 57.4969 62.7119C57.4969 62.3898 57.3969 62.1287 57.1969 61.9288C56.997 61.7288 56.7304 61.5566 56.3971 61.4122C56.075 61.2678 55.7139 61.129 55.314 60.9957C54.9252 60.8623 54.5364 60.7124 54.1476 60.5458C53.7588 60.368 53.3978 60.1514 53.0645 59.8959C52.7424 59.6293 52.4813 59.3016 52.2814 58.9128C52.0814 58.5129 51.9815 58.013 51.9815 57.4131C51.9815 56.6911 52.1536 56.069 52.498 55.5469C52.8535 55.0248 53.3423 54.6304 53.9643 54.3638C54.5864 54.0861 55.3029 53.9473 56.1139 53.9473C56.9359 53.9473 57.6857 54.0917 58.3633 54.3805C59.0521 54.6693 59.6186 55.0637 60.0629 55.5636L58.3633 57.2465C58.0079 56.8799 57.6468 56.6078 57.2803 56.43C56.9248 56.2523 56.5193 56.1634 56.0639 56.1634C55.6084 56.1634 55.2474 56.2523 54.9808 56.43C54.7142 56.5967 54.5809 56.841 54.5809 57.1632C54.5809 57.4631 54.6808 57.7075 54.8808 57.8964C55.0808 58.0741 55.3418 58.2296 55.664 58.3629C55.9972 58.4962 56.3582 58.6295 56.747 58.7628C57.1469 58.8961 57.5413 59.0517 57.9301 59.2294C58.3189 59.4071 58.6744 59.6349 58.9965 59.9126C59.3298 60.1792 59.5964 60.5235 59.7963 60.9457C59.9963 61.3567 60.0963 61.8677 60.0963 62.4786C60.0963 63.6006 59.6964 64.4837 58.8965 65.128C58.0967 65.7612 56.9914 66.0778 55.5806 66.0778ZM61.5294 65.8945V57.7964H64.0788V65.8945H61.5294ZM62.8124 56.68C62.4125 56.68 62.0793 56.5467 61.8127 56.2801C61.5572 56.0023 61.4294 55.6691 61.4294 55.2803C61.4294 54.8804 61.5572 54.5471 61.8127 54.2805C62.0793 54.0139 62.4125 53.8806 62.8124 53.8806C63.2124 53.8806 63.5401 54.0139 63.7956 54.2805C64.0511 54.5471 64.1788 54.8804 64.1788 55.2803C64.1788 55.6691 64.0511 56.0023 63.7956 56.2801C63.5401 56.5467 63.2124 56.68 62.8124 56.68ZM65.8741 65.8945V53.7973H68.4235V65.8945H65.8741ZM72.7682 65.8945L69.3357 57.7964H72.0851L74.4179 64.5448H73.2181L75.5509 57.7964H78.2503L74.8178 65.8779L72.7682 65.8945ZM82.9399 66.0778C82.0623 66.0778 81.2791 65.9001 80.5904 65.5446C79.9128 65.178 79.3796 64.6726 78.9908 64.0283C78.602 63.384 78.4076 62.6564 78.4076 61.8455C78.4076 61.0345 78.5964 60.3125 78.9741 59.6793C79.3629 59.035 79.885 58.5295 80.5404 58.163C81.1958 57.7964 81.9346 57.6131 82.7566 57.6131C83.5564 57.6131 84.2618 57.7853 84.8728 58.1296C85.4837 58.474 85.9614 58.9517 86.3058 59.5626C86.6612 60.1736 86.839 60.8735 86.839 61.6622C86.839 61.8066 86.8279 61.9621 86.8057 62.1287C86.7946 62.2842 86.7668 62.4675 86.7223 62.6786L79.7406 62.6953V60.9457L85.6393 60.929L84.5395 61.6622C84.5284 61.1956 84.4562 60.8124 84.3229 60.5124C84.1896 60.2014 83.9896 59.9681 83.723 59.8126C83.4675 59.646 83.1509 59.5626 82.7733 59.5626C82.3733 59.5626 82.0234 59.6571 81.7235 59.8459C81.4347 60.0237 81.2069 60.2791 81.0403 60.6124C80.8848 60.9457 80.807 61.3511 80.807 61.8288C80.807 62.3065 80.8903 62.7175 81.057 63.0618C81.2347 63.3951 81.4791 63.6562 81.7901 63.845C82.1123 64.0227 82.49 64.1116 82.9232 64.1116C83.3231 64.1116 83.6842 64.045 84.0063 63.9117C84.3285 63.7672 84.6117 63.5562 84.8561 63.2785L86.2558 64.6781C85.8559 65.1447 85.3727 65.4946 84.8061 65.7279C84.2396 65.9612 83.6175 66.0778 82.9399 66.0778ZM88.0696 65.8945V57.7964H90.619V65.8945H88.0696ZM90.619 61.4455L89.5526 60.6124C89.7636 59.6682 90.1191 58.935 90.619 58.4129C91.1189 57.8908 91.8132 57.6298 92.7018 57.6298C93.0906 57.6298 93.4294 57.6909 93.7183 57.813C94.0182 57.9241 94.2793 58.1019 94.5014 58.3463L92.9851 60.2625C92.874 60.1403 92.7352 60.0459 92.5685 59.9792C92.4019 59.9126 92.2131 59.8792 92.002 59.8792C91.5799 59.8792 91.2411 60.0125 90.9856 60.2791C90.7412 60.5346 90.619 60.9234 90.619 61.4455ZM98.8799 65.8945V54.1306H100.746L105.378 61.3456H104.429L109.044 54.1306H110.927V65.8945H108.311V58.5462L108.778 58.6629L105.762 63.3618H104.029L101.029 58.6629L101.479 58.5462V65.8945H98.8799ZM116.949 66.0778C116.071 66.0778 115.288 65.9001 114.6 65.5446C113.922 65.178 113.389 64.6726 113 64.0283C112.611 63.384 112.417 62.6564 112.417 61.8455C112.417 61.0345 112.606 60.3125 112.983 59.6793C113.372 59.035 113.894 58.5295 114.55 58.163C115.205 57.7964 115.944 57.6131 116.766 57.6131C117.566 57.6131 118.271 57.7853 118.882 58.1296C119.493 58.474 119.971 58.9517 120.315 59.5626C120.67 60.1736 120.848 60.8735 120.848 61.6622C120.848 61.8066 120.837 61.9621 120.815 62.1287C120.804 62.2842 120.776 62.4675 120.732 62.6786L113.75 62.6953V60.9457L119.648 60.929L118.549 61.6622C118.538 61.1956 118.465 60.8124 118.332 60.5124C118.199 60.2014 117.999 59.9681 117.732 59.8126C117.477 59.646 117.16 59.5626 116.782 59.5626C116.382 59.5626 116.033 59.6571 115.733 59.8459C115.444 60.0237 115.216 60.2791 115.049 60.6124C114.894 60.9457 114.816 61.3511 114.816 61.8288C114.816 62.3065 114.9 62.7175 115.066 63.0618C115.244 63.3951 115.488 63.6562 115.799 63.845C116.121 64.0227 116.499 64.1116 116.932 64.1116C117.332 64.1116 117.693 64.045 118.015 63.9117C118.338 63.7672 118.621 63.5562 118.865 63.2785L120.265 64.6781C119.865 65.1447 119.382 65.4946 118.815 65.7279C118.249 65.9612 117.627 66.0778 116.949 66.0778ZM122.079 65.8945V57.7964H124.628V65.8945H122.079ZM127.261 65.8945V61.1623C127.261 60.7513 127.133 60.4347 126.878 60.2125C126.633 59.9792 126.328 59.8626 125.961 59.8626C125.706 59.8626 125.478 59.9181 125.278 60.0292C125.078 60.1292 124.917 60.2736 124.795 60.4624C124.684 60.6513 124.628 60.8846 124.628 61.1623L123.645 60.729C123.645 60.0847 123.784 59.5349 124.062 59.0794C124.339 58.6129 124.717 58.2574 125.195 58.013C125.672 57.7575 126.211 57.6298 126.811 57.6298C127.378 57.6298 127.883 57.7575 128.327 58.013C128.783 58.2685 129.144 58.624 129.41 59.0794C129.677 59.5349 129.81 60.0792 129.81 60.7124V65.8945H127.261ZM132.443 65.8945V61.1623C132.443 60.7513 132.315 60.4347 132.06 60.2125C131.815 59.9792 131.51 59.8626 131.143 59.8626C130.888 59.8626 130.66 59.9181 130.46 60.0292C130.26 60.1292 130.099 60.2736 129.977 60.4624C129.866 60.6513 129.81 60.8846 129.81 61.1623L128.344 60.9623C128.366 60.2736 128.527 59.6848 128.827 59.1961C129.138 58.6962 129.544 58.3129 130.044 58.0463C130.555 57.7686 131.127 57.6298 131.76 57.6298C132.382 57.6298 132.932 57.7631 133.409 58.0297C133.898 58.2852 134.281 58.6573 134.559 59.1461C134.848 59.6237 134.992 60.2014 134.992 60.879V65.8945H132.443ZM141.292 66.0612C140.747 66.0612 140.248 65.9501 139.792 65.7279C139.337 65.4946 138.965 65.1891 138.676 64.8114C138.387 64.4226 138.22 63.9894 138.176 63.5117V60.0959C138.22 59.6182 138.387 59.1961 138.676 58.8295C138.965 58.4518 139.337 58.1574 139.792 57.9463C140.248 57.7353 140.747 57.6298 141.292 57.6298C142.058 57.6298 142.736 57.813 143.325 58.1796C143.925 58.5462 144.391 59.0461 144.724 59.6793C145.069 60.3125 145.241 61.0345 145.241 61.8455C145.241 62.6564 145.069 63.3784 144.724 64.0116C144.391 64.6448 143.925 65.1447 143.325 65.5113C142.736 65.8779 142.058 66.0612 141.292 66.0612ZM140.842 63.7617C141.197 63.7617 141.508 63.6784 141.775 63.5117C142.053 63.3451 142.269 63.1174 142.425 62.8286C142.58 62.5397 142.658 62.212 142.658 61.8455C142.658 61.4678 142.58 61.1345 142.425 60.8457C142.269 60.5569 142.053 60.3347 141.775 60.1792C141.508 60.0125 141.197 59.9292 140.842 59.9292C140.486 59.9292 140.17 60.0125 139.892 60.1792C139.614 60.3347 139.398 60.5569 139.242 60.8457C139.098 61.1345 139.026 61.4678 139.026 61.8455C139.026 62.2231 139.103 62.5564 139.259 62.8452C139.414 63.1341 139.625 63.3618 139.892 63.5284C140.17 63.6839 140.486 63.7617 140.842 63.7617ZM136.626 65.8945V53.7973H139.176V59.7793L138.759 61.7455L139.142 63.7117V65.8945H136.626ZM150.535 66.0778C149.658 66.0778 148.874 65.9001 148.186 65.5446C147.508 65.178 146.975 64.6726 146.586 64.0283C146.197 63.384 146.003 62.6564 146.003 61.8455C146.003 61.0345 146.192 60.3125 146.569 59.6793C146.958 59.035 147.48 58.5295 148.136 58.163C148.791 57.7964 149.53 57.6131 150.352 57.6131C151.152 57.6131 151.857 57.7853 152.468 58.1296C153.079 58.474 153.557 58.9517 153.901 59.5626C154.256 60.1736 154.434 60.8735 154.434 61.6622C154.434 61.8066 154.423 61.9621 154.401 62.1287C154.39 62.2842 154.362 62.4675 154.318 62.6786L147.336 62.6953V60.9457L153.234 60.929L152.135 61.6622C152.124 61.1956 152.051 60.8124 151.918 60.5124C151.785 60.2014 151.585 59.9681 151.318 59.8126C151.063 59.646 150.746 59.5626 150.368 59.5626C149.969 59.5626 149.619 59.6571 149.319 59.8459C149.03 60.0237 148.802 60.2791 148.636 60.6124C148.48 60.9457 148.402 61.3511 148.402 61.8288C148.402 62.3065 148.486 62.7175 148.652 63.0618C148.83 63.3951 149.074 63.6562 149.385 63.845C149.708 64.0227 150.085 64.1116 150.518 64.1116C150.918 64.1116 151.279 64.045 151.602 63.9117C151.924 63.7672 152.207 63.5562 152.451 63.2785L153.851 64.6781C153.451 65.1447 152.968 65.4946 152.401 65.7279C151.835 65.9612 151.213 66.0778 150.535 66.0778ZM155.665 65.8945V57.7964H158.214V65.8945H155.665ZM158.214 61.4455L157.148 60.6124C157.359 59.6682 157.714 58.935 158.214 58.4129C158.714 57.8908 159.408 57.6298 160.297 57.6298C160.686 57.6298 161.025 57.6909 161.313 57.813C161.613 57.9241 161.874 58.1019 162.097 58.3463L160.58 60.2625C160.469 60.1403 160.33 60.0459 160.164 59.9792C159.997 59.9126 159.808 59.8792 159.597 59.8792C159.175 59.8792 158.836 60.0125 158.581 60.2791C158.336 60.5346 158.214 60.9234 158.214 61.4455Z",
    fill: "#523A48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_374_95697",
    x: 274.534,
    y: 34.6593,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_95697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_95697",
    x: 261.692,
    y: 40.5593,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_95697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_95697",
    x: 206.524,
    y: -23.0006,
    width: 175.527,
    height: 90.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43584,
    result: "effect1_foregroundBlur_374_95697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddddd_374_95697",
    x: -51.8396,
    y: 23.7547,
    width: 163.851,
    height: 163.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_95697",
    result: "effect2_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_95697",
    result: "effect3_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_95697",
    result: "effect4_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_95697",
    result: "effect5_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.1771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_95697",
    result: "effect6_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_95697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_374_95697",
    x: -11.8801,
    y: 52.8262,
    width: 83.6226,
    height: 95.8338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.512338
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.0787208 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.11309 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_95697",
    result: "effect2_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31828
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_95697",
    result: "effect3_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13541
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.16691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_95697",
    result: "effect4_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.73483
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.201279 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_95697",
    result: "effect5_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_95697",
    result: "effect6_dropShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_95697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_374_95697",
    x: 25.1484,
    y: 52.7086,
    width: 9.25684,
    height: 12.1521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.132245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_374_95697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_374_95697",
    result: "effect2_innerShadow_374_95697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_95697",
    x: 27.1915,
    y: 52.2335,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_95697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_95697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_95697",
    x: 27.412,
    y: 52.4735,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_95697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_95697",
    x: 28.7851,
    y: 52.1649,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_95697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_95697",
    x1: 3.0375,
    y1: 6.9043,
    x2: 299.817,
    y2: 197.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475341,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_95697",
    x1: 261.219,
    y1: 13.3647,
    x2: 340.343,
    y2: 122.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_95697",
    x1: 359.177,
    y1: 90.0005,
    x2: 264.798,
    y2: 166.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#828283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_374_95697",
    x1: 249.04,
    y1: -0.794958,
    x2: 243,
    y2: 146.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2BFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A7A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_95697",
    x1: 248.729,
    y1: -0.512577,
    x2: 324.832,
    y2: 104.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCB7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB7B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_95697",
    x1: 318.477,
    y1: -20.9744,
    x2: 263.751,
    y2: 125.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_95697",
    x1: 295.315,
    y1: 52.6492,
    x2: 276.746,
    y2: 77.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_95697",
    x1: 301.998,
    y1: 33.8048,
    x2: 272.092,
    y2: 74.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_374_95697",
    x1: 292.495,
    y1: 34.1926,
    x2: 280.376,
    y2: 50.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_374_95697",
    x1: 266.831,
    y1: 56.9185,
    x2: 290.938,
    y2: 77.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_95697",
    x1: 283.612,
    y1: 44.0495,
    x2: 265.043,
    y2: 69.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_95697",
    x1: 301.403,
    y1: 29.4841,
    x2: 301.403,
    y2: 38.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_95697",
    x1: 317.193,
    y1: 65.5085,
    x2: 317.193,
    y2: 72.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_95697",
    x1: 264.15,
    y1: 26.5243,
    x2: 264.15,
    y2: 33.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_95697",
    x1: 259.654,
    y1: 11.132,
    x2: 318.57,
    y2: 89.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#B1B1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_95697",
    x1: 29.777,
    y1: 52.8262,
    x2: 25.3616,
    y2: 58.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_95697",
    x1: 31.7613,
    y1: 52.8262,
    x2: 27.1784,
    y2: 58.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_95697",
    x1: 34.4059,
    y1: 52.8262,
    x2: 29.9905,
    y2: 58.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_95697",
    x1: 29.777,
    y1: 58.7773,
    x2: 25.3616,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_95697",
    x1: 31.7613,
    y1: 58.7773,
    x2: 27.1784,
    y2: 64.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_95697",
    x1: 34.4059,
    y1: 58.7773,
    x2: 29.9905,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_374_95697",
    x1: 34.4056,
    y1: 52.8262,
    x2: 22.3105,
    y2: 57.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_374_95697",
    x1: 25.1484,
    y1: 52.8262,
    x2: 37.2436,
    y2: 57.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_374_95697",
    x1: 29.777,
    y1: 52.8262,
    x2: 29.777,
    y2: 64.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_374_95697",
    x1: 25.1484,
    y1: 52.8262,
    x2: 33.9792,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_374_95697",
    x1: 34.4056,
    y1: 52.8262,
    x2: 25.5748,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_374_95697",
    x1: 29.777,
    y1: 58.7772,
    x2: 29.0351,
    y2: 64.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_374_95697",
    x1: 29.7769,
    y1: 52.8259,
    x2: 27.7932,
    y2: 58.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_374_95697",
    x1: 31.7742,
    y1: 58.7725,
    x2: 27.6656,
    y2: 61.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_374_95697",
    x1: 29.7769,
    y1: 52.8262,
    x2: 29.7769,
    y2: 53.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_95697"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_95697"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_95697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 52.8262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_95697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 52.8262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberSilver);
export default __webpack_public_path__ + "static/media/member_silver.507f26733992175ae1962ede225c0a12.svg";
export { ForwardRef as ReactComponent };